import { useTranslation } from 'react-i18next';
import ButtonList from '../ButtonList';
import { useEffect, useRef, useState } from 'react';
import { useRestContext } from 'components/form/RestInputContext';
import ValidationModal from '../ModalConfirm/ValidationModal';
import { useParams } from 'react-router-dom';
import CancelModal from '../ModalConfirm/CancelModal';
import { Card, Space } from 'antd';
import { useDispatch } from '@redux';
import { validationChecklist } from '@redux/ordersReturn/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';

export default function Validation() {
  const { t } = useTranslation();
  const refModal = useRef<{ open: () => void }>();
  const refCancelModal = useRef<{ open: () => void }>();
  const { record } = useRestContext();
  const params = useParams();
  const dispatch = useDispatch();

  const [validation, setValidation] = useState([]);

  useEffect(() => {
    if (record?.id) {
      dispatch(
        validationChecklist({
          data: { id: record?.id },
          options: { isRequestApi: true },
        }),
      ).then((data) => {
        const convert = [
          {
            text: 'ordersReturn.validation.nonreturnableItem',
            value: data?.payload?.hasNonreturnableItem,
          },
          {
            text: 'ordersReturn.validation.thirtyPercentDiscountItem',
            value: data?.payload?.hasThirtyPercentDiscountItem,
          },
          {
            text: 'ordersReturn.validation.giftItem',
            value: data?.payload?.hasGiftItem,
          },
        ];
        setValidation(convert);
      });
    }
  }, [record?.id]);

  return (
    <>
      <Card title={t('ordersReturn.validation.title')}>
        <Space size={10} direction="vertical" className="mb-[30px]">
          {validation?.map((e) => (
            <Space size={12} className="align-center" key={e.key}>
              {!e.value ? (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  style={{
                    color: '#88C041',
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faCircleXmark}
                  style={{
                    color: '#E20000',
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                />
              )}
              <div>{t(e.text)}</div>
            </Space>
          ))}
        </Space>
        <ButtonList
          btnOkText={t('common.button.approve')}
          onOk={() => refModal.current.open()}
          onCancel={() => refCancelModal.current.open()}
          hiddenOKButton={!!record?.exchangeId}
          isShowButton={!record?.isMarketPlace}
        />
      </Card>
      <ValidationModal
        id={record?.id || params?.id}
        ref={refModal}
        initValue={{
          returnMethod: record?.returnMethod,
          whoPayShippingFee: record?.whoPayShippingFee,
        }}
      />
      <CancelModal
        id={record?.id || params?.id}
        ref={refCancelModal}
        initValue={{
          cancelReason: record?.cancelReason,
        }}
      />
    </>
  );
}
